import { render, staticRenderFns } from "./EditorLeftbar.vue?vue&type=template&id=9739ed48&scoped=true&"
import script from "./EditorLeftbar.vue?vue&type=script&lang=js&"
export * from "./EditorLeftbar.vue?vue&type=script&lang=js&"
import style0 from "./EditorLeftbar.vue?vue&type=style&index=0&id=9739ed48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9739ed48",
  null
  
)

export default component.exports